import { render } from "./Aktuell.vue?vue&type=template&id=9245928e&scoped=true"
import script from "./Aktuell.vue?vue&type=script&lang=js"
export * from "./Aktuell.vue?vue&type=script&lang=js"

import "./Aktuell.vue?vue&type=style&index=0&id=9245928e&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9245928e"]])

export default __exports__